import { Link } from "react-router-dom";

// État vide élégant : icône, message, invitation à contribuer (CTA).
export default function EmptyState({ icon: Icon, title, text, ctaLabel, ctaTo, testId }) {
  return (
    <div
      className="bg-white border border-dashed border-slate-300 rounded-2xl p-8 md:p-10 text-center"
      data-testid={testId}
    >
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-2xl bg-[#FFF4EC] text-[#E05638] grid place-items-center">
          <Icon size={22} />
        </div>
      )}
      <div className="mt-3 font-heading font-extrabold text-[#172A3A]">{title}</div>
      {text && <p className="mt-1 text-sm text-slate-500 max-w-md mx-auto">{text}</p>}
      {ctaTo && (
        <Link to={ctaTo} className="mt-4 inline-flex items-center gap-1.5 btn-shine text-white font-semibold px-5 py-2.5 rounded-xl">
          {ctaLabel}
        </Link>
      )}
    </div>
  );
}
